// extracted by css-extract-rspack-plugin
export default {"header":"_ceK6_KmBecWUAVr","title":"THPUdoR1Uf4H8G_K","searchWrapper":"KUG6k1d4dukiSZL9","search":"u8rQU5bHTecfU0No","skeletonRows":"sKZ6o0sQdL0D0J9B"};